var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 21,
    viewBox: "0 0 9 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9416 6.28919V4.60154C5.9416 3.79097 6.43292 3.59976 6.78713 3.59976C7.12992 3.59976 8.95049 3.59976 8.95049 3.59976V0H5.97588C2.6661 0 1.9234 2.66865 1.9234 4.39786V6.28919H0V8.82898V10.4917H1.94245C1.94245 15.2678 1.94245 21 1.94245 21H5.79687C5.79687 21 5.79687 15.1888 5.79687 10.4917H8.64579L8.77148 8.83729L9 6.28504H5.9416V6.28919Z",
    fill: "#343434"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.e1d67bb3.svg";
export { ForwardRef as ReactComponent };